import React, { Component } from 'react';
import api from '../../../services/api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import NovoLoja from "./novaLoja";
import EditarLoja from "./editarLoja";
import Erros from '../../../components/Erro';


class Loja extends Component {
    state = {
        localizarNome: "",
        cliente: {},
        lojas: []
    }

    async componentDidMount() {
        await api.get(`/Cliente/id/${this.props.match.params.idCliente}`).then(response => {
            this.setState({ cliente: response ? response.data : null });
        });

        await api.get(`/Loja/${this.props.match.params.idCliente}/todos`).then(response => {
            this.setState({ lojas: response ? response.data : null });
        });
    }

    handleInputLocalizarNome = e => {
        this.setState({ localizarNome: e.currentTarget.value });
    }

    handleLocalizar = async e => {
        e.preventDefault();
        await api.get(`/Loja/${this.props.match.params.idCliente}/razaoSocial/${encodeURIComponent(this.state.localizarNome === '' ? '%' : this.state.localizarNome)}`).then(response => {
            this.setState({ lojas: response ? response.data : null });
        });
    }

    handleExcluir = async id => {
        if (window.confirm('Dejesa realmente excluir?')) {
            await api.delete('/Loja?id=' + id).then(response => {
                if (response) {
                    this.setState({ lojas: this.state.lojas.filter(f => f.id !== id) });
                }
            });
        }
    }

    render() {
        const { localizarNome, cliente, lojas } = this.state;
        return (
            <div className="container" style={{ marginTop: 20 }}>
                <div className="card">
                    <div className="card-header">
                        <Link to={`/clientes/${cliente.id}`}><h5>{cliente.nome}</h5></Link>
                        Lojas
                    </div>
                    <Erros />
                    <div className="card-body">
                        <h5 className="card-title">Localizar</h5>
                        <div>
                            <form onSubmit={this.handleLocalizar}>
                                <div className="form-row">
                                    <div className="col-md-4 pt-2">
                                        <label className="sr-only">Nome</label>
                                        <input type="text" onChange={this.handleInputLocalizarNome} value={localizarNome} className="form-control" id="inputLocalizar" placeholder="Razão Social" />
                                    </div>
                                    <div className="col-md-1 pt-2">
                                        <div style={{ display: "inline-flex" }}>
                                            <button type="submit" className="btn btn-primary mx-sm-0 mb-2">Localizar</button>
                                            <Link className="btn btn-success mx-sm-4 ml-2 mb-2" to={`/lojas/novo/${cliente.id}`}>Nova Loja</Link>
                                        </div>
                                    </div>
                                </div>
                            </form>
                            <div className="table-responsive">
                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th scope="col">CNPJ</th>
                                            <th scope="col">Razão Social</th>
                                            <th scope="col"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {lojas && lojas.map(loja => (
                                            <tr key={loja.id}>
                                                <td>{loja.cnpj}</td>
                                                <td>{loja.razaoSocial}</td>
                                                <td style={{ textAlign: "right" }}>
                                                    <div style={{ display: "inline-flex" }}>
                                                        <Link className="mx-sm-1 ml-2 mb-2" to={`/lojas/editar/${loja.clienteId}/${loja.id}`}><FontAwesomeIcon className="text-primary ml-2" icon={faEdit} /></Link>
                                                        <button type="button" className="mx-sm-1 ml-2 mb-2" style={{ border: 'none', backgroundColor: 'transparent' }} onClick={() => this.handleExcluir(loja.id)} ><FontAwesomeIcon className="text-danger ml-2" icon={faTrashAlt} /></button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export { Loja, NovoLoja, EditarLoja };